import { Wallet } from "@lib/types/Billing";
import { AppContext } from "@lib/types";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";

type Props = {
  context: AppContext;
  customerId?: string;
  leadId?: string;
  item: Wallet;
};

export const getWalletLinkNoFilter = (context: AppContext) => {
  switch (context) {
    case AppContext.CUSTOMER:
      return getRoute(ROUTES.ADMIN.CUSTOMER.WALLET_ACCOUNTS.LIST);
    case AppContext.CUSTOMER_LEAD:
      return getRoute(ROUTES.ADMIN.CUSTOMER_LEAD.WALLET_ACCOUNTS.LIST);
    default:
      return getRoute(ROUTES.WALLET_ACCOUNTS.LIST);
  }
};

export const getWalletLink = (props: Props) => {
  const { context, customerId, leadId, item } = props;

  switch (context) {
    case AppContext.CUSTOMER:
      return getRoute(ROUTES.ADMIN.CUSTOMER.WALLET_ACCOUNTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
        [ROUTES.URL_PARAMS.CUSTOMER_ID]: customerId,
      });

    case AppContext.CUSTOMER_LEAD:
      return getRoute(ROUTES.ADMIN.CUSTOMER_LEAD.WALLET_ACCOUNTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
        [ROUTES.URL_PARAMS.CUSTOMER_LEAD_ID]: leadId,
        [ROUTES.URL_PARAMS.CUSTOMER_ID]: customerId,
      });

    default:
      return getRoute(ROUTES.WALLET_ACCOUNTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
      });
  }
};
